var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-table-column", {
    key: _vm.code,
    attrs: { label: _vm.name, "min-width": 200, fixed: false, align: "center" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (scope) {
          return [
            _vm.edit
              ? _c("ik-table-image-oss", {
                  ref: "input_" + scope.$index + "_" + "code",
                  attrs: {
                    line: scope.$index,
                    code: _vm.code,
                    name: _vm.name,
                    "default-value": _vm.defaultValue,
                    "min-length": _vm.minLength,
                    "max-length": _vm.maxLength,
                    require: _vm.getRequire,
                  },
                  on: { onFieldChange: _vm.onFieldChange },
                  model: {
                    value: scope.row[_vm.code],
                    callback: function ($$v) {
                      _vm.$set(scope.row, _vm.code, $$v)
                    },
                    expression: "scope.row[code]",
                  },
                })
              : _c("ik-table-image-oss-tag", {
                  attrs: {
                    code: _vm.code,
                    name: _vm.name,
                    "default-value": _vm.defaultValue,
                    value: scope.row[_vm.code],
                  },
                }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }